import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeCountries } from './normalize';

export const fetchCountries = createProvider(api.fetchCountries).andThen(normalizeCountries);
